import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { RECEIVE } from "@/data/content";
import { Reveal, MaskReveal, SectionLabel } from "./primitives";

export default function ReceiveSection() {
  return (
    <section id="recebe" className="relative bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-3xl">
          <Reveal><SectionLabel>O QUE VOCÊ RECEBE</SectionLabel></Reveal>
          <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-brand-navy sm:text-4xl lg:text-5xl">
            <MaskReveal lines={["Não são apenas aulas."]} />
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-5 text-base leading-relaxed text-brand-navy/60 md:text-lg">
              {RECEIVE.subtitle}
            </p>
          </Reveal>
        </div>

        <div className="mt-14 flex flex-wrap justify-center gap-4">
          {RECEIVE.items.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: (i % 4) * 0.06, ease: [0.16, 1, 0.3, 1] }}
                className="group relative flex w-full flex-col overflow-hidden rounded-3xl border border-brand-navy/8 bg-brand-mist/50 p-6 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-brand-gold/40 hover:bg-white hover:shadow-[0_24px_50px_-24px_rgba(10,25,47,0.2)] sm:w-[calc(50%-0.5rem)] md:p-7 lg:w-[calc(25%-0.75rem)]"
              >
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand-navy/5 text-brand-navy transition-transform duration-300 group-hover:scale-110 group-hover:bg-brand-gold/15 group-hover:text-brand-goldDark">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 font-display text-base font-semibold tracking-tight text-brand-navy">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-navy/55">
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
